/* eslint-disable no-console */
import { capitalizeFirstLetter, encodeKebabCase } from '../../../utils/string-utils';
import { pushToDataLayer } from '../../../utils/ga-ecommerce-utils';


const getProductVariantCode = (state) => {
  const {
    fabric,
    model,
    // projectionUpgradeModel,
    projectionUpgradeSelected,
    projectionWithProUpgradeModel,
    proUpgrade,
    proUpgradeModel,
    size,
  } = state;
  let modelName = model;
  // XL upgrade
  /* if (projectionUpgradeSelected === 'Yes' && projectionUpgradeModel !== '') {
    modelCode = projectionUpgradeModel;
  } */
  // PRO upgrade
  if (proUpgrade === 'Yes') {
    modelName = proUpgradeModel;
  }
  // PRO XL upgrade
  if (proUpgrade === 'Yes' && projectionUpgradeSelected === 'Yes' && projectionWithProUpgradeModel !== '') {
    modelName = projectionWithProUpgradeModel;
  }
  const url = `GetProductVariantCode?fabric=${fabric}&model=${modelName}&size=${size}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const appendOptionParamsToProductVariantCode = (itemNumber, state) => {
  const {
    cordSide,
    frameColor,
    mount,
  } = state;
  let code = itemNumber;
  if (mount === 'Soffit Bracket') {
    code += 'S';
  }
  if (cordSide === 'Left Side') {
    code += 'L';
  }
  if (frameColor === 'White') {
    code += 'W';
  }
  return code;
};

const getAwningItemNumber = (state, callback) => {
  getProductVariantCode(state)
    .then((data) => {
      const { variantCode } = data;
      let itemNumber = variantCode;
      if (itemNumber !== '') {
        itemNumber = appendOptionParamsToProductVariantCode(variantCode, state);
      }
      if (callback) {
        callback(itemNumber, variantCode);
      }
    });
};

const getPrice = (state) => {
  // Match price based on selected collection
  const {
    fabricCollection,
    price,
  } = state;
  let s = '';
  Object.keys(price).forEach((key) => {
    const shortColl = encodeKebabCase(fabricCollection);
    const containsColl = key.indexOf(shortColl) !== -1;
    if (containsColl) {
      s = price[key];
    }
  });
  // console.log(`Price: ${s}`);
  return s;
};

// Repalce dashes w/ asterisks
const encodeModelCode = code => (
  code.replace(/--/g, '**')
);

const convertPropsToUrlParams = (props) => {
  let s = '';
  Object.keys(props).forEach((key) => {
    const propName = capitalizeFirstLetter(key);
    s += `${propName}=${props[key]}&`;
  });
  return s.substring(0, s.lastIndexOf('&'));
};

const getUrlParam = (prop) => {
  if (prop === 'N/A') {
    return 'N';
  }
  return prop.charAt(0);
};

const addAwningToSstParamList = (state) => {
  const {
    aluminumHood,
    cordSide,
    fabric,
    fabricCode,
    fabricCollection,
    frameColor,
    hasFrameColorOpt,
    masonryKit,
    model,
    modelCode,
    mount,
    projection,
    rafterAdapterBrackets,
    series,
    size,
    valanceStyle,
    proUpgrade,
    proScreenColor,
    led,
  } = state;
  const props = {
    cordSide: getUrlParam(cordSide),
    fabricCode,
    fabricCollection,
    fabricName: fabric,
    frameColor: getUrlParam(frameColor),
    hasFrameColorOpt,
    hood: getUrlParam(aluminumHood),
    masonryKit: getUrlParam(masonryKit),
    modelCode: encodeModelCode(modelCode),
    modelName: model,
    mount: getUrlParam(mount),
    price: getPrice(state),
    projection: Math.floor(projection),
    rafterAdapterBrackets: getUrlParam(rafterAdapterBrackets),
    series,
    size,
    valanceStyle: getUrlParam(valanceStyle),
    proUpgrade,
    proScreenColor,
    led,
  };
  const p1 = convertPropsToUrlParams(props);
  // console.log(p1);
  const url = `AddAwningToSstParamList?${p1}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const addAwningToGtmDataLayer = (state) => {
  const {
    itemNumber,
    model,
    series,
    sstDescription,
    sstDiscount,
  } = state;
  pushToDataLayer({
    event: 'add_to_cart',
    ecommerce: {
      items: [
        {
          item_id: itemNumber,
          item_name: model,
          affiliation: 'sunsetter.com',
          coupon: sstDiscount,
          currency: 'USD',
          discount: 0,
          index: 0,
          item_brand: 'SunSetter',
          item_category: 'Awnings',
          item_category2: series,
          item_category3: '',
          item_category4: '',
          item_category5: '',
          item_list_id: '',
          item_list_name: '',
          item_variant: sstDescription,
          location_id: '',
          price: getPrice(state),
          quantity: 1,
        },
      ],
    },
  });
};

const resetInputs = () => {
  const checkedInputs = document.querySelectorAll('input:checked');
  [].map.call(checkedInputs, (input) => {
    input.checked = false;
  });
};

export {
  addAwningToGtmDataLayer,
  addAwningToSstParamList,
  getAwningItemNumber,
  resetInputs,
};
/* eslint-enable no-console */
